<template>
  <transition v-if="ifInnResult || editType" name="el-zoom-in-top">
    <el-form
      ref="contragentForm"
      :model="contragentForm"
      :rules="rules"
      label-width="120px"
      class="contragent_form"
      label-position="top"
    >
      <el-row
        :gutter="24"
        style="
          display: flex;
          justify-content: space-between;
          margin-bottom: 12px;
        "
      >
        <el-col :span="12">
          <el-form-item label="Название организации" required>
            <el-input
              v-model="contragentForm.org_name"
              type="textarea"
              :rows="3"
              :readonly="true"
              placeholder="ООО 'Название организации'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="address" label="Адрес организации">
            <el-input
              v-model="contragentForm.address"
              :rows="3"
              type="textarea"
              placeholder="Адрес организации"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" style="display: flex; margin-bottom: 20px">
        <el-col :span="12">
          <el-form-item label="Патент">
            <el-input
              v-model="contragentForm.patent"
              type="text"
              placeholder="Новороссийск"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row
        v-if="contragList.length"
        :gutter="24"
        style="
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
        "
      >
        <el-col :span="24">
          <el-select
            v-model="showPassportIdFromProp"
            placeholder="Просмотр организаций"
            size="small"
            @change="$emit('onChangeOrg', showPassportIdFromProp)"
          >
            <el-option
              v-for="item in contragList"
              :key="item.id"
              :label="item.organization.short_name"
              :value="item.id"
            />
          </el-select>
        </el-col>
      </el-row>
      <el-row
        :gutter="24"
        style="
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
        "
      >
        <el-col :span="12">
          <el-form-item label="Телефон" prop="phone" required>
            <el-input
              v-model="contragentForm.phone"
              v-mask="'+7 (###) ###-##-##'"
              type="text"
              placeholder="Контактный телефон"
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="E-mail" prop="email">
            <el-input
              v-model="contragentForm.email"
              type="text"
              placeholder="Адрес почтового ящика"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row
        :gutter="24"
        style="
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
        "
      >
        <el-col :span="12">
          <el-form-item label="БИК Банка" prop="bik">
            <el-input
              v-model="contragentForm.bik"
              type="text"
              placeholder="БИК"
            />
            <el-button
              size="small"
              style="width: 100%"
              type="info"
              plain
              @click="$emit('checkBik')"
            >
              Проверить БИК
            </el-button>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Название банка" prop="name_bank">
            <el-input
              v-model="contragentForm.name_bank"
              type="textarea"
              :rows="3"
              :readonly="true"
              placeholder="Название банка"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row
        :gutter="24"
        style="display: flex; justify-content: space-between"
      >
        <el-col :span="12">
          <el-form-item label="Номер счета" prop="checking_account">
            <el-input
              v-model="contragentForm.checking_account"
              placeholder="Номер счета"
            />
            <div v-if="errorRs.code > 0" style="padding-top: 5px; color: red">
              {{ errorRs.message }}
            </div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Корреспондентский счет" prop="core_account">
            <el-input
              v-model="contragentForm.core_account"
              :readonly="true"
              placeholder="Кор счет"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item class="btn-wrap">
        <el-button
          v-if="!editType"
          style="flex-grow: 1; width: 20%"
          type="danger"
          @click="$emit('clearDialogForm')"
        >
          Очистить
        </el-button>
        <el-button
          v-if="!editType"
          style="flex-grow: 1"
          type="primary"
          @click="submitForm('contragentForm', true)"
        >
          Сохранить и перейти к документам
        </el-button>
        <el-button
          style="flex-grow: 1; width: 35%"
          type="primary"
          @click="submitForm('contragentForm', false)"
        >
          Сохранить
        </el-button>
      </el-form-item>
    </el-form>
  </transition>
</template>

<script>
export default {
  props: {
    editType: {
      type: Boolean,
      default: false,
    },
    ifInnResult: {
      type: Boolean,
      default: false,
    },
    showPassportId: {
      type: String || Number || null,
      default: null,
    },
    contragList: {
      type: Array,
      default: () => [],
    },
    contragentData: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  data() {
    return {
      errorRs: {
        code: 0,
        message: '',
      },
      showPassportIdFromProp: null,
      contragentForm: {
        org_name: '',
        address: '',
        patent: '',
        phone: '',
        email: '',
        bik: '',
        name_bank: '',
        core_account: '',
        checking_account: '',
      },
      rules: {
        org_name: [
          {
            required: true,
            message: 'Название организации обязательно',
            trigger: 'change',
          },
        ],
        // address: [
        //   {
        //     required: true,
        //     message: 'Адрес организации обязателен',
        //     trigger: 'blur',
        //   },
        // ],
        phone: [
          {
            required: true,
            message: 'Телефон организации обязателен',
            trigger: 'submit',
          },
          {
            min: 18,
            message: 'Неверный формат номера',
            trigger: 'submit',
          },
        ],
        // email: [
        //   {
        //     required: false,
        //     message: 'E-mail организации обязателен',
        //     trigger: 'change',
        //   },
        // ],
        // bik: [
        //   {
        //     required: true,
        //     message: 'Бик Банка обязателен',
        //     trigger: 'change',
        //   },
        // ],
        // name_bank: [
        //   {
        //     required: true,
        //     message: 'Название банка не может быть пустым',
        //     trigger: 'change',
        //   },
        // ],
        // core_account: [
        //   {
        //     required: true,
        //     message: 'Не указан номер корр.счета',
        //     trigger: 'change',
        //   },
        // ],
        // checking_account: [
        //   {
        //     required: true,
        //     message: 'Номер расчетного счета не может быть пустым',
        //     trigger: 'change',
        //   },
        // ],
      },
    }
  },
  watch: {
    showPassportId: {
      immediate: true,
      handler(val) {
        this.showPassportIdFromProp = val
      },
    },
    contragentData: {
      immediate: true,
      handler(val) {
        val ? (this.contragentForm = val) : null
      },
      deep: true,
    },
  },
  methods: {
    submitForm(formName, flag) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$emit('saveContragent', flag)
        } else {
          console.log('error submit!!')

          return false
        }
      })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style lang="sass">
.contragent_form
  .el-form-item__label
    line-height: 10px
  .btn-wrap
    width: 100%
    padding-top: 20px
    margin-top: 20px
    border-top: 0.5px solid grey
    .el-form-item__content
      width: 100%
      display: flex
      justify-content: space-between
</style>
